import API from '../../../services/API'

// Mirrors the server's review cadence (routers/governance/risks.js /
// helpers/cqcCentre/modules/riskRegister.js) so the "overdue" flag in the
// grid matches the CQC Centre's gaps: annual review, with a never-reviewed
// risk getting its year from the date it was added.
const REVIEW_WINDOW_DAYS = 365

export const isReviewOverdue = (lastReview, createdAt) => {
    const baseline = lastReview || createdAt
    if (!baseline) return false
    return new Date(baseline).getTime() + REVIEW_WINDOW_DAYS * 86400000 < Date.now()
}

const getRows = ({ page, limit, setRows, setTotal, setStats, setLoading }) => {
    setLoading?.(true)
    API.get(`/riskregister?page=${page}&limit=${limit}`)
        .then((res) => {
            if (res.status !== 200) return
            const rows = res.data.risks.map((risk) => {
                const currentRating =
                    risk.currentRatingConsequence * risk.currentRatingLikelihood ||
                    risk.initialRatingConsequence * risk.initialRatingLikelihood ||
                    0
                return {
                    id: risk._id,
                    riskID: risk.riskID,
                    riskOwner: risk.riskOwner,
                    title: risk.title,
                    description: risk.description,
                    category: risk.category,
                    currentRating,
                    targetRating:
                        risk.targetRatingConsequence * risk.targetRatingLikelihood || 0,
                    lastReview: risk.lastReview,
                    reviewOverdue: isReviewOverdue(risk.lastReview, risk.createdAt),
                    cqcActivityType: risk.cqcActivityType,
                    cqcQualityStatementKeys: risk.cqcQualityStatementKeys ?? [],
                }
            })
            setRows(rows)
            setTotal(res.data.totalRisks)
            setStats?.(res.data.stats)
        })
        .catch((e) => console.log(e))
        .finally(() => setLoading?.(false))
}

export default getRows
